export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11233.de3ec962.jpg";